import { Platform, View } from 'react-native';

// Landing page is web-only
// Returns empty View for native platforms (they use mobile-specific onboarding)
export const LandingScreen = Platform.select({
  web: () => require('./Landing.web.jsx').default,
  default: () => () => <View />,
})();

export default LandingScreen;
